import Schema from "AppReact/schema";
import { file } from "types/orderEvent";

export default {
  attachments: Schema(file, "array", { defaultValue: [] }),
  index: Schema('integer', "primitive-nullable", { defaultValue: null }),
  length: Schema('integer', "primitive-nullable", { defaultValue: null }),
};
